module.exports = __webpack_public_path__ + "img/cycle-3_a.51ab4ac0.png";